import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class UserSearchStateService {
  filters: any = {};
  filters_clean: boolean = false;
  tab: number = 0;

  
private state: { [tabKey: string]: any } = {};

  set(tabKey: string, data: any) {
    this.state[tabKey] = structuredClone(data);
  }

  get(tabKey: string): any | null {
    return this.state[tabKey] ? structuredClone(this.state[tabKey]) : null;
  }

}
